import { toast } from 'react-toastify'

/**
 * Note:
 *       Client has asked to remove the the toaster (both success and error),
 *       But there's a possibility that error toasters will be included in the future (to show proper feedback of error to users)
 *       So here we are returning all toaster helpers function with nothing and not removing the function call in all games,
 *       if they ask to include error toasters again, simply remove the return from openErrorToaster
 */

export const openErrorToaster = ({ message, toasterId = '' }) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openSuccessToaster = ({ message, toasterId = '' }) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openInfoToaster = ({ message, toasterId = '' }) => {
  toast.info(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openWarningToaster = ({ message, toasterId = '' }) => {
  toast.warn(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}
